import { render } from "./PaginationsPage.vue?vue&type=template&id=3262e0a0&ts=true"
import script from "./PaginationsPage.vue?vue&type=script&lang=ts"
export * from "./PaginationsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__